import $ from 'jquery'

import LiveInputsTextInput from './text_input'

export default class LiveInputsSelectInput extends LiveInputsTextInput {
  inputFilter() {
    return "[data-behaviour~='live-inputs-select-input']"
  }

  constructor(liveInputs) {
    super(liveInputs)
    this.handleChangeEvent = this.handleChangeEvent.bind(this)
    this.handleFocusEvent = this.handleFocusEvent.bind(this)
    this.handleMouseEnterEvent = this.handleMouseEnterEvent.bind(this)
    this.initializeOnChangeListener()
  }

  initializeOnChangeListener() {
    this.liveInputs.on('change', this.inputFilter(), this.handleChangeEvent)
    this.liveInputs.on('focus', this.inputFilter(), this.handleFocusEvent)
    this.liveInputs.on(
      'mouseenter',
      this.inputFilter(),
      this.handleMouseEnterEvent
    )
  }

  handleChangeEvent(event) {
    this.update($(event.target))
  }

  handleFocusEvent(event) {
    this.initializeOriginalValue($(event.target))
  }

  handleMouseEnterEvent(event) {
    this.liveInputs.focus($(event.target))
  }

  teardown() {
    this.liveInputs.off('change', this.inputFilter(), this.handleChangeEvent)
    this.liveInputs.off('focus', this.inputFilter(), this.handleFocusEvent)
    this.liveInputs.off(
      'mouseenter',
      this.inputFilter(),
      this.handleMouseEnterEvent
    )
  }
}
